import React, { useEffect, useRef, useState } from "react";
import ForgeViewer from "./ForgeViewer";
import { OmniScanOverlayManager } from "./OmniScanOverlayManager";
import {FORGE_VIEWER_TYPE_NO_PANEL} from "../../constants/general-constants";
import {FORGE_VIEWER_TYPE_PANEL} from "../../constants/general-constants";

export default function ForgeModal(props) {

  var open = props.open;
  var urn = props.urn;
  var title = props.title;
  var onClose = props.onClose;
  var viewerMode = props.viewerMode || FORGE_VIEWER_TYPE_NO_PANEL;

  var viewerInitialisedRef = useRef(false);
  var selectionHandlerRef = useRef(null);

  var [viewerInstance, setViewerInstance] = useState(null);
 var [selectedAsset, setSelectedAsset] = useState(null);
  var [showAssetPopup, setShowAssetPopup] = useState(false);

  var [showConditionTools, setShowConditionTools] = useState(false);
  var [selectedAssetType, setSelectedAssetType] = useState("Lighting");

  useEffect(function () {
    if (!open) {
      setShowAssetPopup(false);
    }
  }, [open]);

  useEffect(function () {
    viewerInitialisedRef.current = false;
    setViewerInstance(null);
    setShowAssetPopup(false);
    setShowConditionTools(false);
    setSelectedAssetType("Lighting");
  }, [urn]);
  
  
  useEffect(function () {
     console.log(viewerMode);
    }, [viewerMode]);

  if (!open) {
    return null;
  }

  function handleViewerReady(viewer) {
    if (!viewer || viewerInitialisedRef.current) {
      return;
    }

    viewerInitialisedRef.current = true;
    setViewerInstance(viewer);

    console.log("FORGE: Viewer ready in modal");

    attachSelectionListener(viewer);
  }

  function attachSelectionListener(viewer) {
    try {
      if (selectionHandlerRef.current) {
        viewer.removeEventListener(
          window.Autodesk.Viewing.SELECTION_CHANGED_EVENT,
          selectionHandlerRef.current
        );
      }
    } catch (e) {}

	var handler = function (e) {
	  if (e && e.dbIdArray && e.dbIdArray.length > 0) {
	    var dbId = e.dbIdArray[0];

	    // DEMO stub asset info
	    var asset = {
	      dbId: dbId,
	      name: "Lighting Panel LP-" + dbId,
	      type: selectedAssetType || "Lighting",
	      status: Math.random() > 0.8 ? "Fault" : "OK",
	      load: Math.floor(40 + Math.random() * 50),
	      lastCheck: Math.floor(Math.random() * 7) + " days ago",
	      image: "/images/assets/lighting-panel.jpg" // add this asset
	    };

	    setSelectedAsset(asset);
	    setShowAssetPopup(true);
	  }
	};

    selectionHandlerRef.current = handler;

    viewer.addEventListener(
      window.Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      handler
    );
  }

  function clearAllOverlays() {
    if (!viewerInstance) return;
    OmniScanOverlayManager.clearAll(viewerInstance);
    try { viewerInstance.select([]); } catch (e) {}
    setSelectedAsset(null);
    setShowAssetPopup(false);
  }

  function handleClose() {
    try { clearAllOverlays(); } catch (e) {}
    onClose();
  }

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={handleClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.65)",
          zIndex:20000
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "30px",
          left: "30px",
          right: "30px",
          bottom: "30px",
          background: "#ffffff",
          borderRadius: "18px",
          boxShadow: "0 28px 80px rgba(0,0,0,0.70)",
          zIndex: 20001,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        {/* Header */}
        <div
          style={{
            height: "60px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 18px",
            background: "#ffffff",
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            zIndex: 10
          }}
        >
          <div style={{ fontWeight: 800, color: "#111", fontSize: "15px" }}>
            {title ? title : "Revit Model"}
          </div>

          <div
            onClick={handleClose}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              background: "#f1f3f6",
              color: "#333",
              fontSize: "16px",
              fontWeight: 700
            }}
          >
            ✕
          </div>
        </div>

        {/* Body */}
        <div style={{ flex: 1, display: "flex", minHeight: 0 }}>

          {/* Left Panel */}
		  {viewerMode === FORGE_VIEWER_TYPE_PANEL && (
          <div
            style={{
              width: "340px",
              background: "#ffffff",
              borderRight: "1px solid #e9eef5",
              padding: "16px",
              overflowY: "auto"
            }}
          >
            <div style={{ fontWeight: 900, fontSize: "14px", marginBottom: "10px", color: "#111" }}>
              OmniScan Overlay Tools
            </div>

            <div style={{ fontSize: "12px", color: "#666", marginBottom: "14px", lineHeight: "16px" }}>
              Demo mode: randomly shows condition, sensors and 3D Gaussian heat plume.
            </div>

            <button
              type="button"
              style={buttonStyle()}
              onClick={function () {
                setShowConditionTools(!showConditionTools);
              }}
            >
              Show Condition ▾
            </button>

            {showConditionTools && (
              <div style={{ marginTop: "10px", padding: "10px", border: "1px solid #eef2f8", borderRadius: "12px" }}>
                <div style={{ fontWeight: 800, fontSize: "12px", marginBottom: "8px" }}>
                  Asset Type
                </div>

                <select
                  value={selectedAssetType}
                  onChange={function (e) {
                    setSelectedAssetType(e.target.value);
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    borderRadius: "10px",
                    border: "1px solid #e7edf6",
                    background: "#ffffff",
                    fontWeight: 700,
                    fontSize: "12px",
                    marginBottom: "10px"
                  }}
                >
                  <option value="Lighting">Lighting</option>
                  <option value="Fire">Fire</option>
                  <option value="HVAC">HVAC</option>
                  <option value="Electrical">Electrical</option>
                  <option value="Security">Security</option>
                </select>

                <button
                  type="button"
                  style={buttonStyle("#ffb703")}
                  onClick={function () {
                    if (viewerInstance) {
                      OmniScanOverlayManager.applyRAG(viewerInstance);
                    }
                  }}
                >
                  Apply Condition RAG
                </button>
              </div>
            )}

            <div style={{ height: "12px" }} />

            <button
              type="button"
              style={buttonStyle()}
              onClick={function () {
                if (viewerInstance) {
                  OmniScanOverlayManager.addRandomSensors(viewerInstance);
                }
              }}
            >
              Show Sensors (OK / Fault)
            </button>

            <div style={{ height: "12px" }} />

            <button
              type="button"
              style={buttonStyle()}
              onClick={function () {
                if (viewerInstance) {
                  OmniScanOverlayManager.createGaussianHeatmap(viewerInstance);
                }
              }}
            >
              Create 3D Gaussian Heatmap
            </button>

            <div style={{ height: "16px" }} />

            <button
              type="button"
              style={buttonStyle("#f7f9fc")}
              onClick={clearAllOverlays}
            >
              Clear Overlays
            </button>

            <div style={{ marginTop: "16px", fontSize: "12px", color: "#555" }}>
              <div style={{ fontWeight: 800, marginBottom: "6px" }}>Last Selection</div>
              <div style={{
                background: "#f4f6f9",
                border: "1px solid #eef2f8",
                padding: "10px",
                borderRadius: "10px",
                fontWeight: 800
              }}>
                {selectedAsset ? ("dbId: " + selectedAsset) : "None"}
              </div>
            </div>
          </div>
	     )}
          {/* Viewer */}
          <div style={{ flex: 1, position: "relative", background: "#0f1218" }}>
            {urn && (
              <ForgeViewer
                urn={urn}
                viewerLeft={"0px"}
                viewerRight={"0px"}
                viewerTop={"0px"}
                viewerBottom={"0px"}
                viewerZIndex={1}
                loadFunction={null}
                onViewerReady={handleViewerReady}
              />
            )}

            {/* Asset Popup */}
            {showAssetPopup && selectedAsset && (
				<div
				    style={{
				      position: "absolute",
				      top: "80px",
				      right: "40px",
				      width: "300px",
				      background: "#ffffff",
				      borderRadius: "14px",
				      boxShadow: "0 14px 30px rgba(0,0,0,0.45)",
				      padding: "14px",
				      zIndex: 50
				    }}
				  >
				    {/* Header */}
				    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
				      <div style={{ fontWeight: 900, fontSize: "14px" }}>
				        {selectedAsset.name}
				      </div>
				      <div
				        onClick={function () {
				          setShowAssetPopup(false);
				          setSelectedAsset(null);
				        }}
				        style={{ cursor: "pointer", fontWeight: 900 }}
				      >
				        ✕
				      </div>
				    </div>

				    {/* Image */}
				    <div style={{ marginBottom: "10px" }}>
				      <img
				        src="/roombooking/lighting_panel.jpg"
				        alt="asset"
				        style={{
				          width: "100%",
				          borderRadius: "10px",
				          border: "1px solid #eef2f8"
				        }}
				      />
				    </div>

				    {/* Status */}
					<div style={{
					  display: "inline-block",
					  padding: "4px 10px",
					  borderRadius: "999px",
					  fontWeight: 800,
					  fontSize: "11px",
					  background: selectedAsset.status === "Fault" ? "#ffd6d6" : "#d6f5e8",
					  color: selectedAsset.status === "Fault" ? "#c1121f" : "#2a9d8f",
					  marginBottom: "8px"
					}}>
					  Status: {selectedAsset.status}
					</div>

				    {/* Info */}
				    <div style={{ fontSize: "12px", lineHeight: "18px", marginBottom: "10px" }}>
				      <div><strong>Type:</strong> {selectedAsset.type}</div>
				      <div><strong>Load:</strong> {selectedAsset.load}%</div>
				      <div><strong>Last Check:</strong> {selectedAsset.lastCheck}</div>
				    </div>

				    {/* Action */}
				    <div
				      style={{
				        padding: "10px 12px",
				        background: "#ffb703",
				        borderRadius: "10px",
				        textAlign: "center",
				        fontWeight: 900,
				        fontSize: "12px",
				        cursor: "pointer"
				      }}
				      onClick={function () {
				        console.log("Open OmniScan asset:", selectedAsset);
				      }}
				    >
				      Open in OmniScan →
				    </div>
				  </div>
            )}
          </div>
        </div>
      </div>
    </>
  );

  function buttonStyle(bg) {
    var background = bg ? bg : "#f7f9fc";

    return {
      width: "100%",
      padding: "12px 12px",
      borderRadius: "12px",
      border: "1px solid #e7edf6",
      background: background,
      cursor: "pointer",
      fontWeight: 900,
      fontSize: "12px",
      textAlign: "left"
    };
  }
}
